import {Injectable} from '@angular/core';
import {SobBenefits, SobResponse} from "../../../../../models/http/sob-http.model";
import {SobGrouped} from "../models/sob-group.model";

@Injectable({
  providedIn: 'root'
})
export class SobModalListService {

  groupBenefits(data: SobResponse): SobGrouped[] {
    // First create a Map to group benefits by category
    const groupedMap = new Map<string, SobBenefits[]>();

    // Group benefits by category
    data.benefits.forEach(benefit => {
      const category = benefit.category || 'Other';
      if (!groupedMap.has(category)) {
        groupedMap.set(category, []);
      }
      groupedMap.get(category)?.push(benefit);
    });

    return Array.from(groupedMap.entries())
      .map(([category, benefits]): SobGrouped => ({
        category,
        benefits: benefits
      }))
      .sort((a, b) => a.category.localeCompare(b.category));
  }

}
